import { Routes } from '@angular/router';
import { AdviceSearchComponent } from './views/advice-search/advice-search.component';
import { AdviceCategoryComponent } from './views/advice-category/advice-category.component';
import { ArticleComponent } from './views/article/article.component';
import { AdviceComponent } from './views/advice/advice.component';

export const ADVICE_ROUTES: Routes = [
	{ path: 'search', component: AdviceSearchComponent },
	{ path: ':articleCategory', component: AdviceCategoryComponent },
	{ path: ':articleCategory/:articleUrl', component: ArticleComponent },
	{ path: '', component: AdviceComponent },
];
